import {FC, ReactElement, useState} from 'react';
import styled from 'styled-components';
import home_authentication_bg from '../../assets/images/home_authentication_bg.png'
import {sleep} from "utils/met";
import Message from "components/toasts/toasts";
import {useTranslation} from "react-i18next";

const Main = styled.div`
  width: 100%;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: url(${home_authentication_bg}) no-repeat center;
  background-size: 100% 100%;
  min-height: 100%;

  a {
    border: solid 0.01rem transparent;
    color: #08BDC7;
    min-width: 90%;
    font-size: 0.16rem;
    border-radius: 0.22rem;
    height: 0.44rem;
    text-align: center;
    line-height: 0.44rem;
    background-image: linear-gradient(#fbfaec, #eff6da), linear-gradient(164deg, rgba(72, 176, 254, 1), rgba(23, 250, 218, 1));
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
`;

const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.13rem;
  font-weight: 400;
  color: #08BDC7;

  img {
    width: 0.16rem;
  }
`
const TopElementImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 2.2rem;
`;

const CenterElementImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 3.12rem;
`;

const Succeed: FC = (): ReactElement => {
    const {t} = useTranslation();
    const [messageVal, setMessageVal] = useState('')


    const handleComing = async () => {
        setMessageVal(t('home.ComingSoon'))
        await sleep(2000)
        setMessageVal('')
    }

    return (
        <>
            <Main>
                <TopElementImg src={require('img/did_verification_text.png').default} alt=""/>
                <CenterElementImg src={require('img/did_verification_img.png').default} alt=""/>
                <a href='https://f2m.aplink.app/' target='_blank'
                   rel='noreferrer'>{t('home.goFarming')}</a>
                <Text onClick={() => handleComing()}>
                    <p>{t('home.getMore')}</p>
                    <img src={require('img/tips_see_icon.png').default} alt=""/>
                </Text>
            </Main>

            {messageVal && <Message content={messageVal}/>}
        </>
    );
}
;

export default Succeed;
